
import Image from 'react-bootstrap/Image';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';

import im_cfos from "../static/images/CFI_CFOs_circle.png"
import "../style/App.css";
import "../style/Home.css";
import "../style/ReactBootstrapOverride.css";

// className="gradient-aboutus"
// backgroundColor: "#e30a13", borderColor: "#e30a13" 
const AboutUsOurStory = () => {

    return (
        <div>

<Row>
                <Col md={{ span: 3, offset: 1 }}>
                    <h1 style={{textAlign: "center"}}>
                        OUR STORY
                    </h1>
                </Col>
            </Row>
            
        <Container fluid style={ 
            { background: "linear-gradient(to top right, #e30a13, #e30a13, #e30a13, #e30a13, #f18286)" }}>
            <Row className="p-5 m-5">
                <Col>
                    <Image src={im_cfos} alt="im_WhoWeAre" fluid rounded style={{minHeight: "200px", minWidth: "407px"}}></Image>
                </Col>
                <Col>
                    <Row>
                        <p className="col-white">
                            CFI Surgery was born out of a research collaboration between a trainee surgeon and a biomedical engineer. Driven by a commitment to incorporate techniques commonly used in their clinical work to make surgical training more efficient, objective and affordable, a complete training experience was devised that would utilise targeted, structured feedback to minimise the impact of qualitative judgements on skills training.
                        </p>
                    </Row>
                </Col>
            </Row>
        </Container>

        </div>
    );
}

export default AboutUsOurStory;